var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars"},_vm._l((_vm.starsCount),function(item,index){return _c('div',{key:index,ref:"star",refInFor:true,staticClass:"star"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }